import { render, staticRenderFns } from "./help-comp.vue?vue&type=template&id=5a8b2f17&scoped=true"
import script from "./help-comp.vue?vue&type=script&lang=js"
export * from "./help-comp.vue?vue&type=script&lang=js"
import style0 from "./help-comp.vue?vue&type=style&index=0&id=5a8b2f17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b2f17",
  null
  
)

export default component.exports